const formatParagraph = (content:string): string => content.replace(/\\n/g, '\n')

export default formatParagraph
